var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherUserCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.406,
    height: 11.799,
    viewBox: "0 0 14.406 11.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-check",
    "data-name": "Icon feather-user-check",
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    d: "M10.5,26.1V24.9a2.4,2.4,0,0,0-2.4-2.4H3.9a2.4,2.4,0,0,0-2.4,2.4v1.2",
    transform: "translate(0 -10.801)",
    fill: "none",
    stroke: "#16d696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    d: "M11.549,6.9a2.4,2.4,0,1,1-2.4-2.4A2.4,2.4,0,0,1,11.549,6.9Z",
    transform: "translate(-3.15)",
    fill: "none",
    stroke: "#16d696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    d: "M25.5,14.7l1.2,1.2,2.4-2.4",
    transform: "translate(-14.401 -5.4)",
    fill: "none",
    stroke: "#16d696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherUserCheckIcon);
export default __webpack_public_path__ + "static/media/feather-user-check-icon.601de547bdf4ce65ccfdd8821f9dfe5a.svg";
export { ForwardRef as ReactComponent };